import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { getNodeDisplayLabel, useFlowDisplayLanguage } from '../../displayLanguage';
import { CardShell } from '../CardShell';
import { OFFLINE_MODE } from '@/config/offline';

export const ListenNodeView = memo(function ListenNodeView() {
  const displayLanguage = useFlowDisplayLanguage();

  return (
    <CardShell
      kind="listen"
      accent="lime"
      title={getNodeDisplayLabel('listen', displayLanguage)}
      summary={OFFLINE_MODE ? 'オフラインでは使用できません' : displayLanguage === 'en' ? 'Listen for words' : 'ことばを聞き取る'}
    >
      <Handle type="target" position={Position.Left} className="!bg-lime-500" />
      <Handle type="source" position={Position.Right} className="!bg-lime-500" />
    </CardShell>
  );
});
